'use strict';

import buttonsSaveJobs from "../_imports/careers/buttons-saveJobs.common";
import dataLayerContentSharing from '../_imports/dataLayers/content-sharing.common';
import {waitForDependencies} from "../_imports/utils/utils.common";

waitForDependencies(() => {
	buttonsSaveJobs();
	dataLayerContentSharing();
});